import Vue from 'vue'
import * as types from './mutation-types'

const namespaced = true

const getterKeys = {
    'senate': 'senateList',
    'senateRunoff': 'senateRunoffList',
    'house': 'houseList',
    'president': 'presidentList'
}

const initialState = {
    houseList: [],
    senateList: [],
    senateRunoffList: [],
    presidentList: []
}

const mutations = {
    [types.PUT_LANDING_MODELS](state, { models, key }) {
        state[key] = models
            .sort((a, b) => b.date - a.date)
            .map(model => ({
                ...model,
                chamber: model.election.chamber
            }))
    },
    [types.CLEAR_MODELS](state, key) {
        Vue.set(state, key, [])
    }
}

const actions = {
    async putSenateList(context) {
        await fetch("https://forecasting-data.decisiondeskhq.com/2020/prod/senateModels.json")
            .then(response => response.json())
            .then(data => {
                const getterKey = getterKeys["senate"];
                context.commit(types.CLEAR_MODELS, getterKey);
                context.commit(types.PUT_LANDING_MODELS, {
                    models: data.sort((a, b) => b.date - a.date),
                    key: getterKey,
                });
                return data;
            })
            .catch(error => console.error(error));
    },
    async putHouseList(context) {
        await fetch("https://forecasting-data.decisiondeskhq.com/2020/prod/houseModels.json")
            .then(response => response.json())
            .then(data => {
                const getterKey = getterKeys["house"];
                context.commit(types.CLEAR_MODELS, getterKey);
                context.commit(types.PUT_LANDING_MODELS, {
                    models: data.sort((a, b) => b.date - a.date),
                    key: getterKey,
                });
                return data;
            })
            .catch(error => console.error(error));
    },
    async presidentList(context) {
        await fetch("https://forecasting-data.decisiondeskhq.com/2020/prod/presidentialVoteShare.json")
            .then(response => response.json())
            .then(data => {
                const getterKey = getterKeys["president"];
                context.commit(types.CLEAR_MODELS, getterKey);
                context.commit(types.PUT_LANDING_MODELS, {
                    models: data,
                    key: getterKey,
                });
                return data;
            })
            .catch(error => console.error(error));
    },
}

const getters = {
    houseList(state) {
        return state.houseList
    },
    senateList(state) {
        return state.senateList
    },
    senateRunoffList(state) {
        return state.senateRunoffList
    },
    presidentList(state) {
        return state.presidentList
    }
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
